import React, { useEffect, useState } from "react";
import { MdEdit, MdOutlineDeleteForever } from "react-icons/md";
import { useHistory } from "react-router";
import { WebRetailerService } from "../../Services/WebLinkRetailer";
import { Button, Modal, Spinner } from "react-bootstrap-v5";
import { toast } from "react-toastify";
import { CategoryService, SubCategoryService } from "../../Services";
import Select from "react-select";
import Loader from "../../Components/Loader";
import ReactPaginate from "react-paginate";
import { useLocation } from 'react-router-dom'
import CheckAccess from "../../Function/CheckAccess";

let currentPage1 = 1;
let param = {}
export const WebLinkRetailerList = () => {
  const [retailerlist, setRetailerlist] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [searchField, setSearchField] = useState("");
  const [allcat, setAllcat] = useState([]);
  const [allsubcat, setAllsubcat] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);
  const [filtercategory, setFiltercategory] = useState("")
  const [filtersubcategory, setFiltersubcategory] = useState("")

  const history = useHistory();
  const location = useLocation()
  let user_type = localStorage.getItem("user_type")

  const getCategory = async () => {
    // setLoader(true)
    await CategoryService.getCategory()
      // setLoader(false)
      .then((res) => {
        setAllcat(res?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  let addcat = { value: "all", label: "Select one" };

  const categoryList =
    allcat &&
    allcat.map((item, index) => {
      return {
        value: item?._id,
        label: item?.category_name,
      };
    });

  categoryList?.splice(0, 0, addcat);

  // let param = {...pagination, page: currentPage};
   param = {...param, page : currentPage, limit : pagination.limit};

  const handleCategory = async (e) => {
    if(e.value === "all"){
      setFiltercategory("")
    }else{
      setFiltercategory(e.value)
    }
    if (e.value !== "all") {
      param["category"] = e.value;
    }else if(e.value === "all" && filtersubcategory){
      param = {page : currentPage, limit : pagination.limit, subcategory : param.subcategory}
    }
    else if(e.value === "all" && !filtersubcategory){
      param = { page : currentPage, limit : pagination.limit}
    }
    getLinkRetailer();
  };

  const getsubCategory = async () => {
    await SubCategoryService.getSubCategory()
      .then((res) => {
        setAllsubcat(res?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  let addsubcat = { value: "all", label: "Select one" };

  const subcategoryList =
    allsubcat &&
    allsubcat.map((item, index) => {
      return {
        value: item?._id,
        label: item?.subcategory_name,
      };
    });

  subcategoryList?.splice(0, 0, addsubcat);

  const handlesubCategory = async (e) => {
    if(e.value === "all"){
      setFiltersubcategory("")
    }else{
      setFiltersubcategory(e.value)
    }
    if(e.value !== "all") {
      param["subcategory"] = e.value;
    }else if(e.value === "all" && filtercategory){
      param = {page : currentPage, limit : pagination.limit, category : param.category}
    }else if(e.value === "all" && !filtercategory){
      param = { page : currentPage, limit : pagination.limit}
    }
    getLinkRetailer(param);
  };

  const getLinkRetailer = () => {
    setLoader(true);
    // if(searchField){
      param["search"] = searchField;
    // }


    WebRetailerService.getWebLinkRetailer(param)
      .then((res) => {
        setRetailerlist(res.data);
        setLoader(false);
        setPagination({ ...pagination, ...res.pagination });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOpenEdit = (id) => {
    history.push("/edit-web-link-retailer?id=" + id);
    // setSubcategory(item.subcategory_name);
  };

  const handleDeleteModal = async (id) => {
    setDeleteModal(true);
    setDeleteId(id);
  };

  const handleDelete = async () => {
    let obj = { id: deleteId };
    await WebRetailerService.deleteWebRetailer(obj)
      .then((res) => {
        if (res.status === true) {
          toast.success(res.message);
        } else {
          toast.error(res.message);
        }
        getLinkRetailer();
        setDeleteModal(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  useEffect(() => {
    getLinkRetailer();
    getCategory();
    getsubCategory();
  }, [searchField, currentPage]);


  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div className="col-sm-3 mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search By Name/Contact No./Email/Country/City"
                  onChange={(e) => setSearchField(e.target.value)}
                  value={searchField}
                />
              </div>
              <div className="col-sm-3">
                <Select
                  placeholder="Select category"
                  styles={{
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "calc(2.15rem + 2px)",
                      overflowY: "visible",
                    }),

                    placeholder: (provider) => ({
                      ...provider,
                      color: "#a0b0ca",
                    }),
                  }}
                  onChange={(e) => handleCategory(e)}
                  options={categoryList}
                />
              </div>
              <div className="col-sm-3">
                <Select
                  placeholder="Select Sub Category"
                  styles={{
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "calc(2.15rem + 2px)",
                      overflowY: "visible",
                    }),
                    placeholder: (provider) => ({
                      ...provider,
                      color: "#a0b0ca",
                    }),
                  }}
                  onChange={(e) => handlesubCategory(e)}
                  options={subcategoryList}
                />
              </div>

              <div>
              {
                (CheckAccess(63,"add") ||  user_type === "SUPERADMIN" )&& 
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  onClick={() => history.push("/add-web-link-retailer")}
                >
                  Add Retailer
                </button>
              }
              </div>
              <input type="file" className="d-none" />
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    <th>name</th>
                    <th>Contact No.</th>
                    <th>Email</th>
                    <th>Category</th>
                    <th>Sub Category</th>
                    <th>Offer</th>
                    <th>Discount</th>
                    <th>Country</th>
                    {/* {/ <th>State</th> /} */}
                    <th>City</th>
                    {/* {/ <th>Address</th> /} */}
                    <th>Location</th>
                    <th>Retailer Web.</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {retailerlist &&
                    retailerlist.length > 0 &&
                    retailerlist.map((item, key) => (
                      <tr key={key}>
                        <td className="text-body fw-bold">{(pagination.page - 1) * pagination.limit + (key + 1)}</td>
                        <td
                          style={{ cursor: "pointer" }}
                          onClick={() => handleOpenEdit(item._id)}
                        >
                          {item?.name || "-"}
                        </td>
                        <td>{item?.contact_number || "-"}</td>
                        <td>{item?.email || "-"}</td>
                        <td>{item?.category_name || "-"}</td>
                        <td>{item?.subcategory_name || "-"}</td>
                        <td>{item?.is_discount || "-"}</td>
                        <td>{item?.sale_discount || "-"}</td>
                        <td>{item?.country || "-"}</td>
                        {/* {/ <td>{item?.state || "-"}</td> /} */}
                        <td>{item?.city || "-"}</td>
                        {/* {/ <td>{item?.address || "-"}</td> /} */}
                        <td style={{ whiteSpace: "normal" }}>
                          <p>{item?.location || "-"}</p>
                        </td>
                        <td
                          style={{
                            whiteSpace: "normal",
                            // , wordBreak : "break-word"
                          }}
                        >
                          {item?.url || "-"}
                        </td>
                        <td>
                        {
                           (CheckAccess(63,"edit") || user_type === "SUPERADMIN") && 
                          <MdEdit
                            className="pointer"
                            onClick={() => handleOpenEdit(item._id)}
                            style={{
                              fontSize: "22px",
                              color: "rgb(3, 35, 254)",
                            }}
                          />
                        }
                        {
                          (CheckAccess(63,"delete") ||  user_type === "SUPERADMIN") && 
                          <MdOutlineDeleteForever
                            className="pointer"
                            onClick={() => handleDeleteModal(item._id)}
                            style={{ fontSize: "22px", color: "red" }}
                          />
                        }

                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              <div className="text-center">
                {(loader && <Spinner animation="grow" size="sm" />) || ""}
              </div>
              {retailerlist?.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  {/* {/ <Spinner animation="grow" size="sm" /> /} */}
                  {/* {/ <Loader isShow={loader}/> /} */}
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}

              {retailerlist &&
                retailerlist.length > 0 &&
              pagination.total_record > pagination.limit && (
                <ReactPaginate
                  previousLabel={
                    <img
                      src="assets/images/prev.svg"
                      height={15}
                      alt="not found"
                    />
                  }
                  forcePage={currentPage - 1}
                  nextLabel={
                    <img
                      src="assets/images/next.svg"
                      height={15}
                      alt="not found"
                    />
                  }
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={Math.ceil(
                    pagination.total_record / pagination.limit
                  )}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={(e) => onPageChangeEvent(e)}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        animation={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Retailer</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure want to delete the retailer?</Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={() => setDeleteModal(false)}>
            No
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            {(loader && <Spinner animation="grow" size="sm" />) || "Yes"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default WebLinkRetailerList;
